"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevisionModal = void 0;
var React = require("react");
var classNames = require("classnames");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var tenderActions = require("@caddigital/sok-reducers/lib/actions/bid/tender");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var fileListFilter_1 = require("utils/helpers/fileListFilter");
var FileList_1 = require("views/FileListOverview/FileList");
var ListHeader_1 = require("./components/ListHeader");
var ListRow_1 = require("./components/ListRow");
var utils_1 = require("../ReliablePartner/utils");
var dispatch_1 = require("../ReliablePartner/components/utils/dispatch");
var EmptyContent_1 = require("../ReliablePartner/components/EmptyContent");
var FooterButtons_1 = require("./components/FooterButtons/FooterButtons");
var utils_2 = require("../utils");
var RevisionModal = function (props) {
    var dispatchers = (0, dispatch_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var _a = (0, react_redux_1.useSelector)(function (state) { return ({
        isMobile: state.viewport.size !== 'DESKTOP',
        root: state.bid.tender.documents.reliablePartnerRoot,
        fetchStatus: state.revisions.status,
        selectedDocuments: state.bid.tender.documents.selectedDocuments,
        currentUser: state.auth.current,
        connectState: state.bid.tender.isModalOpen,
        revisions: state.revisions.list,
        reliablePartnerReportStatus: state.bid.tender.reliablePartnerReportFetchStatus
    }); }), isMobile = _a.isMobile, root = _a.root, fetchStatus = _a.fetchStatus, selectedDocuments = _a.selectedDocuments, currentUser = _a.currentUser, connectState = _a.connectState, revisions = _a.revisions, reliablePartnerReportStatus = _a.reliablePartnerReportStatus;
    var _b = (0, react_1.useState)([]), items = _b[0], setItems = _b[1];
    var _c = (0, react_1.useState)(false), allSelected = _c[0], setAllSelected = _c[1];
    var _d = (0, react_1.useState)([]), columns = _d[0], setColumns = _d[1];
    var _e = (0, react_1.useState)(tenderActions.sortByOptions), sortByOptions = _e[0], setSortByOptions = _e[1];
    var metaSchema = React.useMemo(function () { return props.metaSchema; }, [props.metaSchema]);
    React.useEffect(function () {
        var _a;
        if (root) {
            dispatchers.fetchRevisions(props.revisionFileUuid);
            var fields = (0, utils_1.mapSchema)(metaSchema, 'bid/tender/card/reliable/modal/header');
            setColumns(fields);
            var meta = columns.find(function (field) { return field.identifier === 'name-meta'; });
            setSortByOptions(__assign(__assign({}, sortByOptions), { sortBy: (_a = meta === null || meta === void 0 ? void 0 : meta.id) !== null && _a !== void 0 ? _a : 0 }));
        }
    }, [root, metaSchema, reliablePartnerReportStatus]);
    React.useEffect(function () {
        var sortedSchema = columns.sort(function (a, b) { return a.order - b.order; });
        var updatedDocuments = (0, utils_2.updateDocumentMetaSchema)(sortedSchema, revisions);
        var updatedItems = (0, fileListFilter_1.filterData)(sortedSchema, updatedDocuments, sortByOptions, tenderActions.searchOptions, sortedSchema);
        setItems(updatedItems);
    }, [sortByOptions, columns, revisions]);
    React.useEffect(function () {
        setAllSelected(items.length > 0 &&
            items.every(function (r) {
                return selectedDocuments.findIndex(function (document) { return document.uuid === r.uuid; }) > -1;
            }));
    }, [selectedDocuments, items]);
    var handleSortByChange = React.useCallback(function (sortBy, order) {
        setSortByOptions(function (prevOptions) { return (__assign(__assign({}, prevOptions), { sortBy: sortBy, order: order })); });
    }, [sortByOptions, columns, revisions]);
    var handleSetColumnFilter = React.useCallback(function (column, value) {
        setSortByOptions(function (prevOptions) {
            var filters = __assign({}, prevOptions.filters);
            if (value === null) {
                delete filters[column];
            }
            else {
                filters[column] = value;
            }
            return __assign(__assign({}, prevOptions), { filters: filters });
        });
    }, []);
    return (React.createElement(sok_ui_1.Modal, { isOpen: connectState, className: 'reliablePartner-modal' },
        React.createElement(sok_ui_1.Header, { onClose: props.closeModal }, (0, translation_1.getLocalization)('bid/tender/card/reliable/modal/header')),
        React.createElement(sok_ui_1.Panel, { title: "".concat((0, translation_1.getLocalization)('bid/tender/card/reliable/panel/title'), " ").concat(items.length), className: "tender-card-documents-modal reliablePartner" },
            React.createElement("div", { className: 'bid-tender-documents-container' },
                !root ||
                    (fetchStatus === 'FETCHING' && (React.createElement("div", { className: 'documents-loading' },
                        React.createElement(sok_ui_1.LoadingSpinner, null)))),
                root && fetchStatus === 'FAILED' && (React.createElement("div", { className: 'documents-failed' },
                    React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                                return root &&
                                    dispatchers.fetchFilesRequest(root, 'reliablePartner');
                            } })))),
                root && revisions.length > 0 && (React.createElement("div", { className: classNames('file-list-wrapper', 'reliablePartner-modal-file-list') },
                    React.createElement(FileList_1.FileList, { key: 'list', isMobile: isMobile, currentFolder: root, items: items, sortByOptions: sortByOptions, searchOptions: tenderActions.searchOptions, convert: function () { return false; }, downloadFolder: dispatchers.downloadFolder(currentUser.token), isAllBookmarked: false, onBookmarkClick: function () { return false; }, onUnBookmarkClick: function () { return false; }, onBookmarkAllFiles: function () { return false; }, staticIconCount: 4, staticIconCountMobile: 3, toggleItem: function (item) {
                            return dispatchers.toggleDocuments([item], !selectedDocuments.find(function (document) { return document.id === item.id; }));
                        }, onSelectAll: function () {
                            return dispatchers.toggleDocuments(items, !allSelected);
                        }, itemSelections: selectedDocuments, isAllFollowed: true, sortBy: handleSortByChange, isAllSelected: allSelected, baseUrl: props.baseUrl, metaDataColumns: columns, onSetColumnFilter: handleSetColumnFilter, navigateTo: function () { return false; }, openNotificationsMenu: function () { return false; }, token: currentUser.token, ListHeader: ListHeader_1.ListHeader, ListRow: (0, ListRow_1.ListRow)('reliablePartner'), parentClass: 'reliablePartner-modal' }))),
                root && fetchStatus === 'FETCHED' && revisions.length === 0 && (React.createElement(EmptyContent_1.EmptyContent, { root: root, section: 'reliablePartner-modal' })))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(FooterButtons_1.FooterButtons, { downloadFiles: dispatchers.downloadFolder(currentUser.token), root: root, selectedDocuments: selectedDocuments, closeModal: props.closeModal }))));
};
exports.RevisionModal = RevisionModal;
